module.exports = __webpack_public_path__ + "static/media/ratio.8c75e2b2.png";